var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-help-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help_FILL0_wght400_GRAD0_opsz48",
    d: "M15.11,21.408a1.033,1.033,0,1,0-.743-.3A1.009,1.009,0,0,0,15.11,21.408Zm-.962-4.015H15.77a4.5,4.5,0,0,1,.179-1.306,3.238,3.238,0,0,1,1.114-1.361,4.812,4.812,0,0,0,1.21-1.4,3.229,3.229,0,0,0,.357-1.513,3.036,3.036,0,0,0-.949-2.338,3.553,3.553,0,0,0-2.516-.88,4.251,4.251,0,0,0-2.379.674,3.848,3.848,0,0,0-1.5,1.856l1.458.55a2.566,2.566,0,0,1,.907-1.2,2.419,2.419,0,0,1,1.43-.426,2.2,2.2,0,0,1,1.513.509,1.662,1.662,0,0,1,.577,1.306,2.022,2.022,0,0,1-.358,1.141A5.478,5.478,0,0,1,15.77,14.12a5.593,5.593,0,0,0-1.224,1.416,3.743,3.743,0,0,0-.4,1.856ZM15,26a10.643,10.643,0,0,1-4.263-.866,11.083,11.083,0,0,1-5.871-5.871,10.988,10.988,0,0,1,0-8.553A10.993,10.993,0,0,1,7.231,7.218a11.276,11.276,0,0,1,3.506-2.351,10.988,10.988,0,0,1,8.552,0,10.983,10.983,0,0,1,5.844,5.844,10.988,10.988,0,0,1,0,8.553,11.276,11.276,0,0,1-2.351,3.506,10.993,10.993,0,0,1-3.493,2.365A10.711,10.711,0,0,1,15,26Zm0-1.65a9,9,0,0,0,6.628-2.736A9.033,9.033,0,0,0,24.35,15a9.02,9.02,0,0,0-2.723-6.628A9.02,9.02,0,0,0,15,5.65,9.033,9.033,0,0,0,8.386,8.372,9,9,0,0,0,5.65,15a9.01,9.01,0,0,0,2.736,6.614A9.01,9.01,0,0,0,15,24.35ZM15,15Z",
    fill: "rgba(0,0,0,0.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpicon);
export default __webpack_public_path__ + "static/media/Helpicon.8cd90b2d8f1484ac54105c435879af05.svg";
export { ForwardRef as ReactComponent };